import PrivateRoute, { Router } from 'components/app-layout/PrivateRoute';

import ProfileFormLayout from './containers/Form'

export default function ProfileLayout() {
  return <Router>
    <PrivateRoute path="/profile/my_profile" component={ProfileFormLayout} />
  </Router>
}
